import { minBreakpoints } from '@noths/polaris-client-ribbons-base';

interface ImageSizeAtBreakpoint {
  L?: string;
  M?: string;
  S?: string;
  XL?: string;
  XS?: string;
  XXS?: string;
}

export const buildImageSizes = ({ L, M, S, XL, XS, XXS = '100vw' }: ImageSizeAtBreakpoint) => {
  // The order of the items in the map needs to be in descending order
  const breakpointsToSizeMap = new Map<number, string | undefined>([
    [minBreakpoints.XL, XL],
    [minBreakpoints.L, L],
    [minBreakpoints.M, M],
    [minBreakpoints.S, S],
    [minBreakpoints.XS, XS],
  ]);

  let breakpointSizes = '';
  for (const [breakpoint, size] of breakpointsToSizeMap) {
    if (size) {
      breakpointSizes = breakpointSizes.concat(`(min-width: ${breakpoint}px) ${size}, `);
    }
  }
  const sizes = breakpointSizes.concat(XXS);
  return sizes;
};
